import React, { useEffect } from 'react';
import LessonsMenu from './components/lessons-menu/lessons-menu';
import useLessons from '@/presentation/hooks/use-lessons';
import { CircleSpinner } from '@/presentation/components';
import Styles from './lessons-styles.scss';
import { lessonState } from './components/atoms';
import { useRecoilValue, useResetRecoilState } from 'recoil';
import { scrollToTop } from '@/main/utils/scroll-utils';
import useUserTracker from '@/presentation/hooks/use-user-tracker';
import { useParams } from 'react-router';
const Lessons = ({ children, loadLessons, manageProgressService, manageLessonsPlans }) => {
    const { firstLoading, menuItemsState } = useLessons({
        loadLessons,
        Styles,
        manageProgressService
    });
    const resetState = useResetRecoilState(lessonState);
    const lessonsState = useRecoilValue(lessonState);
    const { idModule, idLesson } = useParams();
    useUserTracker({ idModule, idLesson });
    useEffect(() => {
        scrollToTop();
        return () => {
            resetState();
        };
    }, []);
    return (React.createElement("div", { className: Styles.lessonsWrap },
        React.createElement(React.Fragment, null,
            React.createElement("div", { className: Styles.lessonContent }, firstLoading ? React.createElement(LoaderComponent, null) : children),
            React.createElement("div", { className: Styles.lessonMenu },
                React.createElement(LessonsMenu, { items: menuItemsState, isLoading: firstLoading, isProgressSaved: lessonsState.isProgressSaved, isProgressSaving: lessonsState.isProgressSaving })))));
};
const LoaderComponent = () => {
    return (React.createElement("div", { style: {
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column'
        } },
        React.createElement("h4", null, "Loading..."),
        React.createElement("br", null),
        React.createElement(CircleSpinner, { size: 60 })));
};
export default Lessons;
